import React from "react";
import { Link } from "react-router-dom";
import { extractTextFromSlateJsonString } from "../utils/extractText";
import LikeButton from "../components/Post/LikeButton";
import ShareButton from "../components/Post/ShareButton";
import { getPostImageUrl, getImageSrcSet } from "../utils/urlBuilder";
import "./PostCard.css";

const PostCard = ({ post }) => {
  // 處理點擊事件，記錄點擊來源
  const handlePostClick = () => {
    // 在 sessionStorage 中記錄點擊來源，供 Post 組件使用
    sessionStorage.setItem('post_clicked_from', window.location.pathname);
  };

  return (
    <div className="post-item">
      <Link
        to={`/posts/${post.uuid || post.id}`}
        className="post-link"
        onClick={handlePostClick}
      >
        <div className="post-item-media" aria-label={post.image ? `${post.title} 的封面圖片` : "無封面圖片"}>
          {post.image ? (
            <img
              src={getPostImageUrl(post.image, 'thumbnail')}
              srcSet={getImageSrcSet(post.image)}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px"
              alt={post.title}
              className="post-item-image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="post-item-placeholder">
              <span className="post-item-placeholder-icon" aria-hidden="true">📷</span>
              <span className="post-item-placeholder-text">尚未提供封面</span>
            </div>
          )}
        </div>
        <div className="post-item-body">
          <h3 className="post-item-title">{post.title}</h3>
          <p className="post-item-content-preview">
            {extractTextFromSlateJsonString(post.content, 100)}...
          </p>
        </div>
      </Link>
      <div className="post-item-footer">
        <LikeButton
          postId={post.uuid || post.id}
          initialLikes={post.likes}
          initialLiked={post.likedByCurrentUser}
        />
        <ShareButton
          postTitle={post.title}
          postUrl={`${window.location.origin}/posts/${post.uuid || post.id}`}
        />
      </div>
    </div>
  );
};

export default PostCard;
